import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import messages from '@/lang/pl'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'
import merge from 'lodash/merge'

Vue.use(VueI18n)

const messages = {}

const _ = { isEmpty, merge }

const defaultLanguage = 'pl'

export const i18n = new VueI18n({
  locale: defaultLanguage, // set locale
  fallbackLocale: defaultLanguage,
  messages
})

const loadedLanguages = [defaultLanguage] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function addMessages(lang, newMessages) {
  //console.log(lang, newMessages);
  let messages = i18n.getLocaleMessage(lang)
  if (!_.isEmpty(messages)) {
    _.merge(messages, newMessages)
  } else {
    messages = newMessages
  }
  i18n.setLocaleMessage(lang, messages)
}

export function loadLanguageFromChunk(lang, chunk, getMessages) {
  getMessages = getMessages || false
  return import(
    `@/lang/${chunk}-${lang}`
    
  ).then(msgs => {
    console.log("from chunk:",lang,msgs,`@/lang/${chunk}-${lang}`);
    addMessages(lang, msgs.default)
    loadedLanguages.push(lang)
    if (getMessages) {
      ////console.log("getMessages",msgs.default)
      return msgs.default
    } else {
      return setI18nLanguage(lang)
    }
  })
}

export function loadLanguageAsync(lang, force, ajaxUrl, cb) {
  // ajaxUrl = ajaxUrl || process.env.IC_AJAX_ROOT + '/ax26hrxl857-a/components/icformozn/connector.php?action=getlanguage';
  if (i18n.locale !== lang || force) {
    if (!loadedLanguages.indexOf(lang) !== -1 || force) {
      // return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}`).then(msgs => {

      return axios({
        method: 'get',
        responseType: 'json',
        url: ajaxUrl,
        withCredentials: true
      })
        .then(msgs => {
          let data = msgs.data.object || msgs.data
          cb = cb || (d => d)
          //console.log("from async:",lang,data);
          addMessages(lang, cb(data))
          
           if (!loadedLanguages.indexOf(lang) !== -1) {
             loadedLanguages.splice( loadedLanguages.indexOf(lang) , 1) 
           }
          loadedLanguages.push(lang);
          return setI18nLanguage(lang)
        })
        .catch(res => {})
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

// loadLanguageAsync(defaultLanguage, true)
